import React from "react";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";
import banner1 from "../banner1.webp"; // Adjust path if needed
import "@fontsource/chivo";

const DaVittorioPage = () => {
  return (
    <div className="bg-white text-black min-h-screen">
      <NavbarWhite />

      <div className="pt-32 px-6 text-center">
        <h1 className="text-4xl sm:text-5xl font-[chivo] text-[#009FB7] mb-10">
          Da Vittorio
        </h1>

        <div className="max-w-4xl mx-auto p-4 sm:p-6 font-[chivo] leading-relaxed text-lg sm:text-xl text-left space-y-6">
  <p>
    Lo stabilimento balneare <strong>"Lido Da Vittorio"</strong> è situato
    nella cittadina di Vico Equense, e più precisamente presso la località
    <strong> "Postali"</strong>, una conca dal panorama mozzafiato dalla quale
    è possibile ammirare da un lato, tutto il Golfo di Napoli, e dall'altro
    la costa verdeggiante che cade a strapiombo sul mare. Meravigliosi e unici
    sono anche i tramonti, con il sole che va a riposare dietro il
    caratteristico scoglio della Margherita. La sua collocazione la rende una
    delle spiagge più incantevoli della Penisola Sorrentina; un ulteriore punto
    di forza della nostra struttura è l'acqua che bagna la spiaggia che per due
    anni consecutivi (2020 e 2021) si è aggiudicata la <strong>Bandiera Blu</strong>.
  </p>

  <p>
    L'attività, nata oltre 40 anni fa, ha sempre profuso un costante impegno
    volto a offrire alla propria clientela il massimo comfort, e presta una
    particolare attenzione a ogni singola esigenza. La spiaggia è
    prevalentemente sabbiosa e con un mare dal fondale basso. La struttura è
    priva di barriere architettoniche ed è accessibile a tutti.
  </p>

  <p>
    Oltre all'affitto degli arredi da spiaggia, presso la nostra struttura è
    possibile noleggiare canoe e pedalò con i quali effettuare escursioni e
    ammirare le bellezze della costa o fermarsi su una delle varie spiaggette
    incontaminate.
  </p>

  <p>
    L'area ristoro è servita da un bar che offre, oltre alla classica
    caffetteria, la possibilità di pranzare o bere aperitivi e cocktail in
    compagnia, comodamente seduti di fronte a un'ammaliante scenario naturale.
  </p>

  <p>
    Siamo certi di poter offrire alla clientela tutto ciò che occorre per
    trascorrere giornate al mare all'insegna della tranquillità e del
    divertimento.
  </p>
</div>


        {/* Banner Image */}
{/* Banner Image */}
<div className="mt-12 mb-16 max-w-5xl mx-auto px-4">
  <img
    src={banner1}
    alt="Lido Da Vittorio Banner"
    className="w-full rounded-xl shadow-md"
  />
</div>

      </div>

      <Footer />
    </div>
  );
};

export default DaVittorioPage;
